export default function CTASection() {
  return (
    <section className="relative w-full py-32 md:py-40 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Soft%20warm%20toned%20textile%20backdrop%20with%20natural%20linen%20and%20cotton%20fabric%20folds%20creating%20gentle%20texture%20abstract%20composition%20in%20cream%20beige%20and%20warm%20sand%20tones%20diffused%20sunlight%20creating%20subtle%20highlights%20minimalist%20background%20with%20organic%20material%20feel%20serene%20and%20clean%20atmosphere%20suitable%20for%20fashion%20branding&width=1920&height=900&seq=cta-bg-css-02&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-black/40" />

      <div className="relative z-10 max-w-4xl mx-auto text-center px-4">
        <h2 className="font-heading text-5xl md:text-7xl font-black text-white tracking-widest mb-5">
          CSSBUY SHEET
        </h2>
        <p className="font-body text-white/75 text-lg md:text-xl mb-12 max-w-xl mx-auto leading-relaxed">
          Your gateway to the best verified fashion finds
          <br />
          updated daily for the community
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="group inline-flex items-center gap-0 bg-white text-foreground-950 font-label font-semibold text-base rounded-full overflow-hidden hover:scale-105 transition-transform duration-300 cursor-pointer"
        >
          <span className="w-14 h-14 flex items-center justify-center bg-accent-500 text-white rounded-full">
            <i className="ri-shopping-bag-line text-xl"></i>
          </span>
          <span className="px-8 whitespace-nowrap">BUY IT NOW</span>
          <span className="w-12 h-12 flex items-center justify-center mr-2">
            <i className="ri-arrow-right-up-line text-xl group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300"></i>
          </span>
        </a>
      </div>
    </section>
  );
}